import React from 'react';
import Hero from '../components/homepage/Hero';
import SubHeroProofPoints from '../components/homepage/SubHeroProofPoints';
import FocusStripes from '../components/homepage/FocusStripes';
import PortfolioTimeline from '../components/homepage/PortfolioTimeline'; // <-- NEW
import FeaturedPortfolio from '../components/homepage/FeaturedPortfolio';
import FounderCallouts from '../components/homepage/FounderCallouts';
import CtaBand from '../components/homepage/CtaBand';

const Homepage = () => {
    return (
        <>
            <Hero />
            <SubHeroProofPoints />
            <FocusStripes />
            <PortfolioTimeline /> {/* <-- ADDED HERE */}
            <FeaturedPortfolio />
            <CtaBand />
            <FounderCallouts />
        </>
    );
};

export default Homepage;